// Vendor Libs
import React from 'react';

// Components
import FlexDashboard from '../core/flex-dashboard';
import FlaggedMetadataItems from '../search-data/flagged-metadata-items';
import FlaggedMetadataDetail from '../search-data/flagged-metadata-detail';

// Configs
import getDashboardConfig from '../../../config/flex-dashboard-config';

const dashboardConfig = {
    layout: {
        type: 'row',
        children: [
            {
                type: 'row',
                children: [
                    {
                        type: 'tabset',
                        children: [
                            {
                                type: 'tab',
                                name: 'Flagged Metadata Items',
                                component: FlaggedMetadataItems,
                            },
                        ],
                    },
                ],
            },
            {
                type: 'row',
                children: [
                    {
                        type: 'tabset',
                        children: [
                            {
                                type: 'tab',
                                name: 'Flagged Metadata Detail',
                                component: FlaggedMetadataDetail,
                            },
                        ],
                    },
                ],
                weight: 125,
            },
        ],
    },
};

function DashboardFlaggedMetadataItems() {
    return (
        <FlexDashboard
            dashboardConfig={getDashboardConfig(dashboardConfig)}
            dashboardName="flaggedMetadataItems"
            version="1"
        />
    );
}

export default DashboardFlaggedMetadataItems;
